module.exports = __webpack_public_path__ + "img/furniture.57c1c869.svg";